module.exports = __webpack_public_path__ + "assets/img/688f91142cd506218386e98ffa76d9bf.svg";